<template>
  <div>
    <div class="container">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                v-model="queryForm.qstr"
                placeholder="名稱、備註"
                size="small"
                style="width:100px"
              ></el-input>
            </el-form-item>

            <el-form-item label="顏色" label-width="65px">
              <div
                style="width:335px;marginBottom:-20px"
                >
                <el-checkbox-group v-model="queryForm.colors">
                  <el-checkbox
                    v-for="itemColor in extTagColorList"
                    :key="itemColor.name"
                    :label="itemColor.name"
                    style="width:35px"
                  >
                    <span :style="{ color: itemColor.textColor, marginLeft: '-5px'}" >
                      {{ itemColor.txtLabel }}
                    </span>
                  </el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                style="marginLeft:-10px"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addNewOrg"
            size="small"
            >新增單位</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="organizations"
            @sort-change="sortChange"
            :default-sort="{ prop: 'startDate', order: 'descending' }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="index" :index="indexFormatter" fixed>
            </el-table-column>
            <el-table-column
              prop="code"
              sortable="custom"
              label="單位代號"
              width="170"
            >
            </el-table-column>
            <el-table-column
              label="名稱"
              prop="name"
              sortable="custom"
              width="170"
            >
              <template #default="scope">
                <el-tag :style="getTagStyle(scope.row.color)">{{ scope.row.name }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template #default="scope">
                <el-button size="mini" @click="createSysChannel(scope.row.id)"
                  >建立系統頻道
                </el-button>
                <el-button size="mini" @click="editOrganization(scope.row.id)"
                  >編輯
                </el-button>
                <el-button
                  type="danger"
                  size="mini"
                  @click="deleteOrganization(scope.row.id)"
                  v-if="!isSysOrg(scope.row.code)"
                  >刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>
        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
        <AddEdtOrgDlg
          v-model="addEdtOrgDlgVisible"
          :orgId="dlgOrgId"
          :key="dlgKey"
        ></AddEdtOrgDlg>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddEdtOrgDlg from "@/components/global/AddEdtOrgDlg";
import tagColorsMixin from "@/components/mixin/tagColors.js";
import { SYS_ORG_NAME } from "@/appConfig";
export default {
  name: "orgList",
  mixins: [tagColorsMixin],
  components: {
    AddEdtOrgDlg,
  },
  created() {
    this.$store.dispatch(
      "organization/list",
      {
        max: this.pageSize,
        offset: this.offset,
        sort: this.sort,
        order: this.order,
      },
      {
        root: true,
      }
    );
  },
  data() {
    return {
      dlgOrgId: null,
      dlgKey: 0,
      addEdtOrgDlgVisible: false,
      pageSize: 50,
      currentPage: 1,
      queryForm: {
        qstr: "",
        colors: [],
      },
    };
  },
  methods: {
    isSysOrg (orgCode) {
      return orgCode === SYS_ORG_NAME
    },
    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.query(this.pageSize, 0, this.sort, this.order, queryForm);
    },
    addNewOrg() {
      this.addEdtOrgDlgVisible = true;
      this.dlgOrgId = null;
      this.dlgKey = this.dlgKey ? 0 : 1;
    },
    editOrganization(orgId) {
      /*console.log(`editOrganization: orgId = ${orgId}`);*/
      this.dlgOrgId = orgId;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.addEdtOrgDlgVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.queryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.queryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      this.$store.dispatch("organization/list", {
        max: max,
        offset: offset,
        sort,
        order,
        ...params,
      });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    createSysChannel(orgId) {
        this.$store.dispatch("organization/createSysChannel", orgId).then(() => {
            this.$message({
              type: "success",
              message: "建立成功!",
            });
          }).catch((reason)=>{
            console.log(reason);
          })
    },
    deleteOrganization(orgId) {
      this.$confirm("此操作將永久刪除該單位, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("organization/remove", orgId).then(() => {
            this.query(
              this.pageSize,
              this.offset,
              this.sort,
              this.order,
              this.queryForm
            );
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          /*this.$message({*/
          /*type: 'info',*/
          /*message: '已取消删除'*/
          /*});          */
        });
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("organization/SET_SORT", "id");
        this.$store.commit("organization/SET_ORDER", "ascending");
      } else {
        this.$store.commit("organization/SET_SORT", args.prop);
        this.$store.commit("organization/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.queryForm
      );
    },
  },
  computed: {
    ...mapGetters({
      // 取得資料夾列表
      organizations: "organization/organizations",
      total: "organization/total",
      offset: "organization/offset",
      getOrganizationById: "organization/getOrganizationById",
      sort: "organization/sort",
      order: "organization/order",
    }),
  },
};
</script>

<style></style>
